import { CREATE_USER, createUserBusy, createUserError, createUserSuccess } from "./action";
import { call, put, takeEvery } from "redux-saga/effects";
import { createUser } from "./api";

import { ActionTypes } from "../util";
import { BUSY_GLOBAL } from "../busy/action";
import { logError } from "utils/utils";
import { toSnakeCase } from "controllers/user/saga";

const { REQUEST } = ActionTypes;

export function* createUserSaga(action) {
  const body = toSnakeCase(action.payload);
  try {
    yield put(createUserBusy(BUSY_GLOBAL));
    yield put(createUserError());
    const response = yield call(createUser, body);
    yield put(createUserSuccess(response));
  } catch (error) {
    logError(error);
    yield put(createUserError(error.message));
  } finally {
    yield put(createUserBusy(false));
  }
}

export default function* usersSaga() {
  yield takeEvery(CREATE_USER[REQUEST], createUserSaga);
}
